import React, { useState, useEffect } from 'react';
import { push } from 'react-router-redux';
import { useSnackbar } from 'notistack';
import moment from 'moment';

// @material-ui/core components
import { Grid, Button, IconButton, InputLabel } from '@material-ui/core';
import { DateBox } from 'devextreme-react/date-box';
import Spinner from '../spinner/Spinner';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import NoteAddOutlinedIcon from '@material-ui/icons/NoteAddOutlined';
import DeleteIcon from '@material-ui/icons/Delete';

// core components
import CustomInput from '../CustomInput/CustomInput';
import CustomSelect from '../CustomSelect/CustomSelect';
import CustomRadioButton from '../CustomRadioButton/CustomRadioButton';
import { getUsers, postBooking } from '../../containers/request/components/service';

import { useStyles } from './style';
import { amountPassenger } from '../../utils/constants';

function NewBooking(props) {
  // const bookingStore = useContext(BookingStoreContext);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();
  const [booking, setBooking] = useState({
    user_id: '',
    origin: '',
    destination: '',
    second_origin: '',
    second_destination: '',
    departure_datetime: new Date(),
    return_datetime: new Date(),
    passengers_number: 1,
    observations: '',
    travel_type: 'roundtrip',
  });

  const minDate = new Date(moment().subtract(1, 'seconds'));
  const maxDate = new Date(moment().add(12, 'months'));

  const [requesters, setRequesters] = useState([]);
  const [documents, setDocuments] = useState([]);

  const [validateBooking, setValidateBooking] = useState({
    isCorrectUser: true,
    haveOrigin: true,
    haveDestination: true,
  });

  useEffect(() => {
    const loadUsers = async () => {
      const response = await getUsers();

      if (response.status === 200) {
        const requesterList = response.data.map(user => {
          return { value: user.id, label: user.full_name };
        });

        setRequesters(requesterList);
      }
    };

    loadUsers();
  }, []);

  const handleSelectsChange = name => event => {
    setBooking({
      ...booking,
      [name]: event.target.value,
    });
  };

  const handleSubmitBooking = async () => {
    /** Make insert new booking */
    setIsLoading(true);

    if (checkBooking()) {
      // check travel type ida
      let book = booking;

      if (book.travel_type === 'one_way') {
        book.return_datetime = null;
      }

      if (!!documents.length) {
        book.documents = documents;
      }

      const response = await postBooking(book);
      setIsLoading(false);

      if (!!response && response.status === 200) {
        props.history.push('/requests');
        push('/requests');
      } else if (!response) {
        console.log('error')
      }
    } else {
      setIsLoading(false);
    }
  };

  const checkBooking = () => {
    let result = true;
    let isCorrectUser = true;
    let haveOrigin = true;
    let haveDestination = true;

    if (booking.user_id === '') {
      isCorrectUser = false;
      result = false;
    }

    if (booking.origin === '') {
      haveOrigin = false;
      result = false;
    }

    if (booking.destination === '') {
      //   setValidateBooking({ ...validateBooking, haveDestination: false });
      //   result = false;
      haveDestination = false;
      result = false;
    }

    if (
      booking.travel_type !== 'one_way' &&
      booking.departure_datetime.getTime() >= booking.return_datetime.getTime()
    ) {
      enqueueSnackbar('La fecha de regreso debe ser mayor a la fecha de salida', {
        variant: 'error',
      });
      result = false;
    }
    setValidateBooking({
      ...validateBooking,
      isCorrectUser: isCorrectUser,
      haveOrigin: haveOrigin,
      haveDestination: haveDestination,
    });
    return result;
  };

  const handleChangeTravelType = value => {
    setBooking({ ...booking, travel_type: value });
  };

  const isInDocuments = file => {
    return !!documents.find( d => 
      file.name === d.name && file.lastModified === d.lastModified && file.size === d.size && file.type === d.type
    );
  }

  const handleNewFiles = event => {
    const files = event.target.files;
    const docs = [];
    for (let i = 0; i < files.length; i++) {
      if (!isInDocuments(files[i])) {
        docs.push(files[i])
      }
    }
    setDocuments(documents.concat(docs));
  }

  const deleteDocument = index => {
    const docs = documents.map(d => d); // Cloning the array to delete an element
    docs.splice(index, 1);
    setDocuments(docs);
  }

  const fileSize = (size) => size > 1024 ? `${(size / 1024).toFixed(2)}MB` : `${size}KB` 

  const renderDocuments = () => {
    return (
      <Grid className="documents" container item sm={12} xs={12}>
        <InputLabel shrink >
          Documentos
        </InputLabel>
        <Grid className="document-row" container item sm={12} xs={12}>
          <Grid item sm={4} xs={4}>
            <InputLabel className="header" shrink >
              Nombre
            </InputLabel>
          </Grid>
          <Grid item sm={3} xs={3}>
            <InputLabel className="header" shrink >
              Tamaño
            </InputLabel>
          </Grid>
          <Grid item sm={4} xs={4}>
            <InputLabel className="header" shrink >
              Tipo
            </InputLabel>
          </Grid>
          <Grid item sm={1} xs={1}>
          </Grid>
        </Grid>
        { documents.map( (doc, index) =>
            (
              <Grid key={`${doc.name}${index}`} className="document-row" container item sm={12} xs={12}>
                <Grid item sm={4} xs={4}>
                  <InputLabel shrink >
                    { doc.name }
                  </InputLabel>
                </Grid>
                <Grid item sm={3} xs={3}>
                  <InputLabel shrink >
                    { fileSize(doc.size) }
                  </InputLabel>
                </Grid>
                <Grid item sm={4} xs={4}>
                  <InputLabel shrink >
                    { doc.type }
                  </InputLabel>
                </Grid>
                <Grid item sm={1} xs={1}>
                  <IconButton aria-label="delete" color="secondary" onClick={ () => deleteDocument(index)} >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            )
          )
        }
      </Grid>
    );
  }

  return (
    <div>
      <h3>Crear reservación</h3>
      <div className={classes.container}>
        <Grid container spacing={1}>
          <Grid item sm={12} xs={12}>
            <CustomRadioButton
              name="radio-button-one-way"
              label="Solo ida"
              value="one_way"
              selectedValue={booking.travel_type}
              handleChange={handleChangeTravelType}
            />
            <CustomRadioButton
              name="radio-button-round-trip"
              label="Ida y vuelta"
              value="roundtrip"
              selectedValue={booking.travel_type}
              handleChange={handleChangeTravelType}
            />
            <CustomRadioButton
              name="radio-button-multi-places"
              label="Multidestino"
              value="multi_places"
              selectedValue={booking.travel_type}
              handleChange={handleChangeTravelType}
            />
          </Grid>

          <Grid item sm={2} xs={12}>
            <CustomSelect
              id="selectRequester"
              labelText="Solicitante"
              formControlProps={{
                fullWidth: true,
              }}
              value={booking.user_id}
              options={requesters}
              onChange={handleSelectsChange('user_id')}
            />
            {validateBooking.isCorrectUser === false ? (
              <span
                style={{
                  display: 'block',
                  color: 'red',
                  marginTop: '5px',
                }}
              >
                Debe seleccionar un solicitante
              </span>
            ) : (
              ''
            )}
          </Grid>
          <Grid item sm={3} xs={12}>
            <CustomInput
              id="inputOrigin"
              labelText="Origen"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: booking.origin,
                onChange: handleSelectsChange('origin'),
              }}
            />
            {validateBooking.haveOrigin === false ? (
              <span
                style={{
                  display: 'block',
                  color: 'red',
                  marginTop: '5px',
                }}
              >
                Debe insertar un Origen
              </span>
            ) : (
              ''
            )}
          </Grid>
          <Grid item sm={3} xs={12}>
            <CustomInput
              id="txtDestination"
              labelText="Destino"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: booking.destination,
                onChange: handleSelectsChange('destination'),
              }}
            />
            {validateBooking.haveDestination === false ? (
              <span
                style={{
                  display: 'block',
                  color: 'red',
                  marginTop: '5px',
                }}
              >
                Debe insertar un destino
              </span>
            ) : (
              ''
            )}
          </Grid>
          <Grid item sm={4} xs={12}>
            <Grid container spacing={1}>
              <Grid item sm={6} xs={12}>
                <InputLabel shrink style={{ marginBottom: '5px' }}>
                  Fecha de salida
                </InputLabel>
                <DateBox
                  type="datetime"
                  width="100%"
                  value={booking.departure_datetime}
                  max={maxDate}
                  min={minDate}
                  onValueChanged={({ value }) =>
                    setBooking({
                      ...booking,
                      departure_datetime: value,
                    })
                  }
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                {booking.travel_type === 'roundtrip' && (
                  <>
                    <InputLabel shrink style={{ marginBottom: '5px' }}>
                      Fecha de regreso
                    </InputLabel>

                    <DateBox
                      value={booking.return_datetime}
                      max={maxDate}
                      min={minDate}
                      onValueChanged={({ value }) =>
                        setBooking({
                          ...booking,
                          return_datetime: value,
                        })
                      }
                      type={'datetime'}
                      width="100%"
                    />
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
          {booking.travel_type === 'multi_places' && (
            <>
              <Grid item sm={2} xs={6}>
                <p>Otro lugar de destino</p>
              </Grid>
              <Grid item xs={12} sm={3}>
                <CustomInput
                  id="inputSecondOrigin"
                  labelText="Origen"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: booking.second_origin,
                    onChange: handleSelectsChange('second_origin'),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <CustomInput
                  id="inputSecondDestination"
                  labelText="Destino"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    value: booking.second_destination,
                    onChange: handleSelectsChange('second_destination'),
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Grid container spacing={1}>
                  <Grid item sm={6} xs={12}>
                    <InputLabel shrink style={{ marginBottom: '5px' }}>
                      Fecha de regreso
                    </InputLabel>
                    <DateBox
                      type="datetime"
                      width="100%"
                      max={maxDate}
                      min={minDate}
                      value={booking.return_datetime}
                      onValueChanged={({ value }) =>
                        setBooking({
                          ...booking,
                          return_datetime: value,
                        })
                      }
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}></Grid>
                </Grid>
              </Grid>
            </>
          )}

          <Grid sm={5} item xs={12} style={{ paddingRight: '10px' }}>
            <CustomInput
              id="observationTxt"
              labelText="Observaciones"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: booking.observations,
                onChange: handleSelectsChange('observations'),
              }}
            />
          </Grid>

          <Grid item sm={3} xs={12}>
            <CustomSelect
              id="selectPassanger"
              labelText="Cantidad de pasajeros"
              formControlProps={{
                fullWidth: true,
              }}
              value={booking.passengers_number}
              options={amountPassenger}
              onChange={handleSelectsChange('passengers_number')}
            />
          </Grid>
          <Grid item sm={4} xs={6}>
            <div
              style={{
                paddingTop: '24px',
              }}
            >
              <Button
                className="action-button"
                variant="contained"
                color="secondary"
                startIcon={<NoteAddOutlinedIcon />}
                component="label"
              >
                Documentos
                <input type="file" style={{ display: 'none' }} multiple onChange={event => handleNewFiles(event)} />
              </Button>

              <Button
                className="action-button"
                variant="contained"
                color="secondary"
                onClick={() => {
                  handleSubmitBooking();
                }}
                startIcon={<AddCircleOutlineIcon />}
              >
                Crear
              </Button>
            </div>
          </Grid>
          {!!documents.length && renderDocuments()}
        </Grid>
        <Spinner isLoading={isLoading} />
      </div>
    </div>
  );
}

export default NewBooking;
